/* ============================================================
   VALSEN — Patch navigation Shopify (transition de page)
   Le valsen.js d'origine ne declenchait la transition que sur les
   liens finissant par ".html". Sur Shopify les URLs sont propres
   (/collections/foret, /pages/contact...). Ce patch rebranche la
   transition (rideau noir + nom de page) sur les liens internes Shopify.
   Charge APRES valsen.js.
   ============================================================ */
(function(){
  'use strict';

  var ptrans = document.getElementById('ptrans');
  if(!ptrans) return;

  // Table nom + icone + tagline par page, indexee par mot-cle d'URL
  var pageInfo = {
    index:       {ico:'✒', name:'Valsen',               tag:'Papeterie créative'},
    product:     {ico:'❦', name:'Le produit',           tag:'Fiche détaillée'},
    contact:     {ico:'✉', name:'Contact',              tag:'Écrivez-nous'},
    histoire:    {ico:'❧', name:'Notre histoire',       tag:"L'art du quotidien"},
    collections: {ico:'⚜', name:'Collections',          tag:'Quatre univers'},
    boutique:    {ico:'❖', name:'Boutique',             tag:'Tout le catalogue'},
    all:         {ico:'❖', name:'Boutique',             tag:'Tout le catalogue'},
    packs:       {ico:'❉', name:'Packs',                tag:'Objets à offrir'},
    createurs:   {ico:'✦', name:'Créateurs',            tag:'Éditions limitées'},
    cadeaux:     {ico:'🎁', name:'Cadeaux',             tag:'Le moteur à cadeau'},
    journal:     {ico:'❦', name:'Le Journal',           tag:'Inspirations & coulisses'},
    royaume:     {ico:'♛', name:'Royaume',              tag:'Médiéval · Épique'},
    cosmos:      {ico:'✷', name:'Cosmos',               tag:'Astres & galaxies'},
    foret:       {ico:'❧', name:'Forêt enchantée',      tag:'Nature & mystère'},
    mythologie:  {ico:'⚶', name:'Mythologie',           tag:'Légendes antiques'},
    faq:         {ico:'?', name:'Questions fréquentes', tag:'Aide & infos'},
    livraison:   {ico:'✦', name:'Livraison & retours',  tag:'Tout savoir'},
    account:     {ico:'☻', name:'Mon compte',           tag:'Espace personnel'},
    cgv:         {ico:'§', name:'CGV',                   tag:'Conditions de vente'},
    mentions:    {ico:'§', name:'Mentions légales',     tag:'Informations légales'},
    confidentialite: {ico:'§', name:'Confidentialité',  tag:'Vos données'},
    search:      {ico:'⌕', name:'Recherche',            tag:'Trouvez votre pièce'},
    cart:        {ico:'☖', name:'Panier',               tag:'Votre sélection'}
  };

  // Deduit la cle d'apres une URL Shopify
  function keyFromPath(path){
    try {
      var u = new URL(path, window.location.origin);
      var p = u.pathname.replace(/\/$/, '');
      if(p === '' || p === '/') return 'index';
      // Dernier segment significatif
      var segs = p.split('/').filter(Boolean);
      var last = segs[segs.length - 1];
      var first = segs[0];
      // Cas particuliers
      if(first === 'products') return 'product';
      if(first === 'account')  return 'account';
      if(first === 'cart')     return 'cart';
      if(first === 'search')   return 'search';
      if(first === 'blogs')    return 'journal';
      // /collections/xxx ou /pages/xxx -> on prend le dernier segment
      if(pageInfo[last]) return last;
      if(pageInfo[first]) return first;
      return 'index';
    } catch(e){ return null; }
  }

  function fillSig(key){
    var info = pageInfo[key] || pageInfo.index;
    var ico = ptrans.querySelector('.pt-ico'); if(ico) ico.textContent = info.ico;
    var nm  = ptrans.querySelector('.pt-name'); if(nm) nm.textContent = info.name;
    var tg  = ptrans.querySelector('.pt-tag');  if(tg) tg.textContent = info.tag;
  }

  // Est-ce un lien interne a intercepter ?
  function isInternal(a){
    var href = a.getAttribute('href');
    if(!href) return false;
    if(href.charAt(0) === '#') return false;
    if(a.target === '_blank') return false;
    if(a.hasAttribute('download')) return false;
    if(/^(mailto:|tel:|javascript:)/.test(href)) return false;
    // meme domaine
    try {
      var u = new URL(href, window.location.origin);
      if(u.origin !== window.location.origin) return false;
      // Ne pas intercepter le checkout (redirection Shopify)
      if(u.pathname.indexOf('/checkout') === 0) return false;
      if(u.pathname.indexOf('/cart') === 0) return false;
      return true;
    } catch(e){ return false; }
  }

  // Delegation : intercepte les clics sur les liens internes
  document.addEventListener('click', function(e){
    var a = e.target.closest('a');
    if(!a || !isInternal(a)) return;
    // Ctrl / Cmd / Maj / clic molette : ouverture dans un nouvel onglet, sans rideau
    if(e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || (e.button && e.button !== 0)) return;
    // Laisser passer les boutons "ajouter au panier" et autres actions data-add
    if(a.hasAttribute('data-add') || a.closest('[data-no-transition]')) return;

    var href = a.getAttribute('href');
    var key = keyFromPath(href);
    if(!key) return;

    e.preventDefault();
    fillSig(key);

    // Declencher le rideau (meme sequence que le valsen.js d'origine)
    ptrans.style.animation = 'none';
    ptrans.classList.remove('reveal');
    ptrans.style.transition = 'none';
    ptrans.style.transform = 'translateY(-100%)';
    requestAnimationFrame(function(){
      ptrans.style.transition = '';
      ptrans.style.transform = '';
      ptrans.classList.add('cover');
      setTimeout(function(){ window.location.href = href; }, 420);
    });
  }, true);

  // Au chargement : remplir la signature selon la page actuelle
  // (pour que le rideau d'entree affiche le bon nom)
  fillSig(keyFromPath(window.location.pathname));

})();

/* ============================================================
   CORRECTIF — rideau de transition bloque au retour arriere
   Sur mobile surtout, revenir en arriere restaure la page depuis
   le cache du navigateur (bfcache) : le rideau noir affiche avant
   la navigation reste alors visible et bloque l'ecran.
   On le referme systematiquement quand la page est (re)affichee.
   ============================================================ */
(function(){
  'use strict';

  function fermerRideau(){
    var pt = document.getElementById('ptrans');
    if (!pt) return;
    pt.classList.remove('cover');
    pt.classList.remove('reveal');
  }

  // Restauration depuis le cache (retour / avance du navigateur)
  window.addEventListener('pageshow', function(e){
    if (e.persisted) { fermerRideau(); }
    else { setTimeout(fermerRideau, 60); }
  });

  // Navigation dans l'historique
  window.addEventListener('popstate', fermerRideau);

  // Filet de securite : si le rideau reste affiche plus de 3s, on le retire
  window.addEventListener('load', function(){
    setTimeout(function(){
      var pt = document.getElementById('ptrans');
      if (pt && pt.classList.contains('cover')) { fermerRideau(); }
    }, 3000);
  });

})();

/* ============================================================
   SECURITE — rideau bloque au retour arriere
   Au clic, le script pose 'animation:none' sur le rideau pour reprendre la
   main dessus, et ne l'efface pas (l'effacer plus tot relancerait aussitot
   l'animation d'entree, faisant repartir le rideau avant la navigation).
   Ce style subsiste donc dans la page mise en cache. Au retour arriere,
   l'animation d'entree ne peut plus jouer et le rideau reste plein ecran.
   On le degage ici, uniquement dans ce cas.
   ============================================================ */
(function(){
  'use strict';

  function degager(){
    var pt = document.getElementById('ptrans');
    if(!pt) return;
    pt.classList.remove('cover');
    pt.classList.remove('reveal');
    pt.style.animation = '';
    pt.style.transition = '';
    pt.style.transform = '';
  }

  // Page restauree depuis le cache du navigateur (retour / avance)
  window.addEventListener('pageshow', function(e){ if(e.persisted) degager(); });
  window.addEventListener('popstate', degager);

  // Filet : si le rideau couvre encore l'ecran 2,5 s apres le chargement
  window.addEventListener('load', function(){
    setTimeout(function(){
      var pt = document.getElementById('ptrans');
      if(!pt) return;
      var r = pt.getBoundingClientRect();
      if(r.top < window.innerHeight * 0.5 && r.bottom > window.innerHeight * 0.5) degager();
    }, 2500);
  });

})();
